import styled, { css } from 'styled-components'

interface TotalProps {
  limitError?: boolean
}

export const TotalWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `}
`

export const Total = styled.div<TotalProps>`
  ${({ theme, limitError }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    font-size: 0.75rem;
    color: ${!limitError ? theme.colors.stormGray : theme.colors.warning};
    line-height: 1.125;
    gap: 0.25rem;
    .totalLimitErrorIcon {
      width: 1rem;
      height: 1rem;
      color: ${theme.colors.warning};
    }
  `}

  ${({ limitError }) => {
    if (!limitError) {
      return css`
        .totalLimitErrorIcon {
          visibility: hidden;
        }
      `
    }
  }}
`

export const TotalValue = styled.span<TotalProps>`
  ${({ limitError }) => {
    if (limitError) {
      return css`
        font-weight: bold;
      `
    }
  }}
`
